import { progressActionTypes } from './constants';

import type { ProgressActivity, ProgressSubcategoryData, ProgressSubjectData } from '../types';

export function getProgressOverviewRequest() {
	return {
		type: progressActionTypes.GET_PROGRESS_OVERVIEW_REQUEST,
	};
}

export function getProgressOverviewSuccess(
	activity: ProgressActivity,
	subjects: ProgressSubjectData[],
) {
	return {
		type: progressActionTypes.GET_PROGRESS_OVERVIEW_SUCCESS,
		payload: {
			activity,
			subjects,
		},
	};
}

export function getProgressOverviewError(error: unknown) {
	return {
		type: progressActionTypes.GET_PROGRESS_OVERVIEW_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function getProgressDetailsRequest(subcategoryId: number) {
	return {
		type: progressActionTypes.GET_PROGRESS_DETAILS_REQUEST,
		payload: {
			subcategoryId,
		},
	};
}

export function getProgressDetailsSuccess(progressDetails: ProgressSubcategoryData) {
	return {
		type: progressActionTypes.GET_PROGRESS_DETAILS_SUCCESS,
		payload: {
			progressDetails,
		},
	};
}

export function getProgressDetailsError(error: unknown) {
	return {
		type: progressActionTypes.GET_PROGRESS_DETAILS_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function toggleInfoModal(openModal: boolean) {
	return {
		type: progressActionTypes.TOGGLE_INFO_MODAL,
		payload: {
			openModal,
		},
	};
}

export function toggleProgressOnboardingModal(openModal: boolean) {
	return {
		type: progressActionTypes.TOGGLE_PROGRESS_ONBOARDING_MODAL,
		payload: {
			openModal,
		},
	};
}

export function clearProgressDetails() {
	return {
		type: progressActionTypes.CLEAR_PROGRESS_DETAILS,
	};
}
